export default __webpack_public_path__ + "static/media/proposal.f9862d7c.png";